var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "overflow-hidden"
  }, [_c('h1', {
    staticClass: "mt0 ttu",
    staticStyle: {
      "margin": ".67em 0",
      "font-size": "2em"
    }
  }, [_vm._v("\n    " + _vm._s(this.isEnglish ? 'today on tap' : 'dnes na výčape') + "\n    "), _c('span', {
    staticClass: "smp-dark-green"
  }, [_vm._v("\n      " + _vm._s(_vm.today.getDate()) + "."), _c('smp-hair'), _vm._v(_vm._s(_vm.months[_vm.today.getMonth()]) + "\n    ")], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mt4"
  }, [_vm._l((_vm.beersByCategories), function(beersByCategory) {
    return [_c('div', {
      staticClass: "mt4 pt1"
    }, [_c('h2', {
      staticClass: "f1 gold"
    }, [_vm._v(_vm._s(_vm.isEnglish ? beersByCategory.category.nameEn : beersByCategory.category.name))]), _vm._v(" "), _vm._l((beersByCategory.beers), function(beer, i) {
      return _c('smp-beer-item', {
        key: beer['.key'],
        class: {
          mt3: i != 0
        },
        attrs: {
          "beer": beer
        }
      })
    })], 2)]
  })], 2)])
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-32ed8bfb","hasScoped":true}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/BeersOnTap.vue
// module id = 91
// module chunks = 1